package com.anjuros.website.redesign.sections.portal

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.RdBenefitsGridStyle
import com.anjuros.website.redesign.styles.RdFaqBandStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

private val Benefits = listOf(
    RdText.PORTAL_BENEFIT1_TITLE to RdText.PORTAL_BENEFIT1_TEXT,
    RdText.PORTAL_BENEFIT2_TITLE to RdText.PORTAL_BENEFIT2_TEXT,
    RdText.PORTAL_BENEFIT3_TITLE to RdText.PORTAL_BENEFIT3_TEXT,
    RdText.PORTAL_BENEFIT4_TITLE to RdText.PORTAL_BENEFIT4_TEXT,
    RdText.PORTAL_BENEFIT5_TITLE to RdText.PORTAL_BENEFIT5_TEXT,
    RdText.PORTAL_BENEFIT6_TITLE to RdText.PORTAL_BENEFIT6_TEXT,
)

@Composable
fun PortalBenefitsSection() {
    // Pale-blue band, so the plain "get it" section below stands apart from both this and the FAQ.
    RdSection(id = "benefits", labelledBy = "benefits-h", modifier = RdSectionStyle.toModifier().then(RdFaqBandStyle.toModifier())) {
        RdSectionHead(RdText.PORTAL_BENEFITS_EYEBROW, "benefits-h", RdText.PORTAL_BENEFITS_TITLE)
        Div(RdBenefitsGridStyle.toModifier().toAttrs()) {
            Benefits.forEach { (title, text) ->
                Div {
                    H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
                    P { Text(LocalText(text)) }
                }
            }
        }
    }
}
